import styled from '@emotion/styled';
import { IconButton, Tooltip, Typography } from '@innovamat/glimmer-components';
import { useRef } from 'react';

export const EmailWithCopyContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: 100%;

  .copy-icon {
    opacity: 0;
    transition: opacity 0.15s ease;
  }

  &:hover .copy-icon {
    opacity: 1;
  }

  @media (hover: none) and (pointer: coarse) {
    .copy-icon {
      opacity: 0;
    }
  }
`;

const EmailField = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SubtleText = styled(Typography.Body2)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
`;

const StyledTooltip = styled(Tooltip)`
  min-width: 0;
`;

type CopyableEmailProps = {
  email?: string;
  isInvitation?: boolean;
};

export function CopyableEmail({
  email,
  isInvitation,
}: CopyableEmailProps): JSX.Element | null {
  if (!email) return null;

  const textRef = useRef<HTMLParagraphElement>(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
  };

  return (
    <StyledTooltip content={email}>
      <EmailWithCopyContainer>
        <EmailField ref={textRef}>
          {isInvitation ? <SubtleText>{email}</SubtleText> : email}
        </EmailField>
        <IconButton
          className="copy-icon"
          size="S"
          icon="CopyIcon"
          onClick={handleCopy}
        />
      </EmailWithCopyContainer>
    </StyledTooltip>
  );
}